// @flow
import globalNotification from 'live/services/global-notification'
import i18n from 'live/services/i18n'

import _ from 'lodash'
import React, { Component } from 'react'
import { Checkbox } from 'react-bootstrap'
import { ProviderImport } from '../providers/ProviderImport'
import { TypeTreeWellObj } from '../constants/TypeTreeWellObj'
import { WellFile, Revision, FileWellType, WellCache } from '../types/WellTypes'
import WellFileImport from '../types/WellFileImport'
import { ConstantsImport, SEEDS_DRILLING_FILE_TYPE } from '../constants/ConstantsImport'
import webConfig from '../types/webConfig'
import ImportUtil from '../util/ImportUtil'
import WellCard from '../types/WellCard'
import OilField from '../types/OilField'
import WellImportOption from './WellImportOption'
import { SortCompareName, SortCompareFileType } from './../util/SortsUtil'
import NoResults from './NoResults'
import FileIcon from '../../../widget-types/csb-chart/components/FileIcon'
import ImportSeedsDataByDate, { parseSeedsDataToLiveData } from './ImportSeedsDataByDate'
import {
    ErrorStyled,
    ListItemContainer,
    TitleName,
    TreeElement,
    ContainerInput,
    ListItem,
    ContainerSubtitle,
    Subtitle,
    ContentActive,
    Loading,
    ContainerBack,
    OptionContent,
    ContainerCheckBox,
    Content,
    BodyContent,
    StyledDiv
} from '../style/style'
import AnmModel from '../constants/AnmModel'
import ConversionUtil from '../util/ConversionUtil'
import ReplaceFileTypeUtil from '../util/ReplaceFileTypeUtil'
import { canManageWells } from '../../../utils/permission'
import PhasesOptions from './PhasesOptions'
import { Sections } from '../types/SectionCompletionTypes'

const providerImport = new ProviderImport()

type Props = {
    assetName?: string,
    onSelectFile: Function,
    checks?: Array<{ key: string, description: string }>,
    checkedItens?: Record<string, any>,
    onCheck?: Function,
    setEnable?: Function,
    submited?: boolean,
    setSubmited?: Function,
    typeAsset?: TypeAsset,
    typesListShow: Array<string>,
    drillingSections: Sections
}
type State = {
    // lists
    geoTable: { fracturePressure: Array<any>, porePressure: Array<any> },
    list: Array<any>,
    listCache: Array<any>,
    listOpUnitsCache: Array<OpUnit>,
    listOilfieldCache: Array<OilField>,
    listWellCache: Array<WellCache>,
    listFileCache: Array<FileWellType>,
    listRevisionsCache: Array<Revision>,
    listWebConfig: Array<webConfig>,

    // selected
    selectedFile: { name: string, url: string },
    selectedWebConfig: webConfig,

    // booleans
    enable: boolean,
    loaded: boolean,
    showWebConfig: boolean,
    showOptionsImport: boolean,
    showTitle: boolean,

    // titles
    titleOpUnit: string,
    titleOilField: string,
    titleWell: string,
    titleFile: string,

    // aux
    error: any,
    showSearchResults: boolean,
    searchTxt: string,
    currentLevelTree: any,

    // well
    assetName: string,

    // result
    file: { name: string, fileId: string, fileRevision: String, wellName: string }
}

class WellImportData extends Component<Props, State> {
    state = {
        // list
        geoTable: null,
        list: [],
        listCache: [],
        listOpUnitsCache: [],
        listOilfieldCache: [],
        listWellCache: [],
        listFileCache: [],
        listRevisionsCache: [],
        listWebConfig: [],
        timestamp: null,

        // selected
        selectedFile: { name: '', url: '' },
        selectedWebConfig: {},
        selectedCardOptions: {},

        // boolean
        enable: false,
        loaded: false,
        showWebConfig: true,
        showOptionsImport: false,
        showTitle: true,
        showSearchResults: false,

        // titles
        titleOpUnit: '',
        titleOilField: '',
        titleWell: '',
        titleFile: '',

        // aux
        titleTree: {},
        searchTxt: '',
        error: {},
        currentLevelTree: TypeTreeWellObj.OP_UNITS,

        // well
        assetName: this.props.assetName,

        file: {},

        // phase
        phaseOptions: {}
    }

    wellFile: WellFile
    wellCard: WellCard
    valid: boolean
    oilField: any = {}
    showRevisions = false
    isAttachment = this.props.typesListShow === ConstantsImport.attachmentTypes

    constructor(props: Props) {
        super(props)
    }

    componentWillMount() {
        this.getExtensionInstances()
    }

    componentWillReceiveProps({ submited }): void {
        if (submited) {
            if (this.isAttachment) {
                this.getAttachment(this.state.file.fileId, this.state.file.fileRevision)
            } else {
                this.onSubmit()
                this.props.setSubmited(false)
            }
        }
    }

    getExtensionInstances(): void {
        if (canManageWells()) {
            providerImport
                .getWebExtensionInstances()
                .then((webConfigs: Array<webConfig> | { message: string }) => {
                    this.setState({ loaded: true })
                    if (webConfigs?.message?.includes('permission')) {
                        this.setState({
                            error: {
                                msg: ConstantsImport.msg.permission,
                                type: 'permission'
                            }
                        })
                        return
                    } else if (!webConfigs || (webConfigs && webConfigs.length == 0)) {
                        this.setState({
                            error: {
                                msg: ConstantsImport.msg.needInstance,
                                type: 'needregister'
                            }
                        })
                    } else if (webConfigs && webConfigs.length === 1) {
                        const webConfig = webConfigs[0]

                        if (this.isAttachment && !webConfig.enableCsb) {
                            this.defineWebConfigError()
                            return
                        }

                        providerImport.setRequestOptions(webConfig)
                        this.getTree()
                    } else {
                        this.setState({
                            listWebConfig: webConfigs,
                            listCache: webConfigs,
                            error: null,
                            showTitle: false,
                            currentLevelTree: TypeTreeWellObj.WEB_CONFIG
                        })
                    }
                })
                .catch(error => {
                    console.error(error)
                    this.handleError(error)
                })
        }
    }

    getTree = (): void => {
        this.setState({ error: null, searchTxt: '', loaded: false, showWebConfig: false })
        providerImport
            .getWells()
            .then(result => {
                const listResult = result.opunits
                const wellsFound = this.searchWellsByName(listResult, this.props.assetName)
                if (wellsFound && Array.isArray(wellsFound) && wellsFound.length > 0) {
                    this.setState({
                        showTitle: false,
                        currentLevelTree: TypeTreeWellObj.WELLS,
                        titleOpUnit: '',
                        titleOilField: '',
                        titleWell: '',
                        showSearchResults: true,
                        titleFile: '',
                        showOptionsImport: false,
                        list: wellsFound.sort(SortCompareName),
                        listCache: wellsFound.sort(SortCompareName),
                        listWellCache: wellsFound.sort(SortCompareName),
                        listOpUnitsCache: listResult.sort(SortCompareName),
                        loaded: true,
                        error: null,
                        searchTxt: this.state.assetName
                    })

                    return
                }

                this.setState({
                    list: listResult.sort(SortCompareName),
                    listCache: listResult.sort(SortCompareName),
                    listOpUnitsCache: listResult.sort(SortCompareName),
                    loaded: true,
                    error: null
                })
            })
            .catch(error => {
                console.error(error)
                this.handleError(error)
            })
    }

    handleError = (error): void => {
        console.error(error)
        if (error.message?.includes('404') || error.message?.includes('410')) {
            error.msg = ConstantsImport.msg.notFound
        } else if (
            error.response &&
            error.response.status == 500 &&
            error.response.data &&
            error.response.data.message &&
            error.response.data.message.indexOf('local connections') > -1
        ) {
            error.msg = ConstantsImport.msg.onlyLocal
        } else {
            error.msg = ConstantsImport.msg.notConnect
        }
        this.setState({ error: error, loaded: true })
    }

    getByUrl = (
        url: string,
        levelTree: string,
        treeName: string,
        titleTree: string,
        element: Record<string, any>,
        index: number
    ): void => {
        this.setState({ error: null, loaded: false })
        providerImport
            .getByUrl(url)
            .then((result: any) => {
                const listResult = result[treeName]
                this.setState({ result: result })
                if (result.revision?.content) this.setState({ geoTable: ImportUtil.convertGeoTable(result) })

                switch (levelTree) {
                    case TypeTreeWellObj.WELLS:
                        const newListFilter = listResult.filter(el => {
                            return this.props.typesListShow.includes(el.file_type)
                        })

                        this.setState({
                            searchTxt: '',
                            showTitle: true,
                            showSearchResults: false,
                            assetName: titleTree,
                            list: newListFilter.sort(SortCompareName),
                            listCache: newListFilter.sort(SortCompareName),
                            listFileCache: newListFilter.sort(SortCompareName),
                            titleODWell: titleTree,
                            titleWell: titleTree,
                            titleOilField: element.oilFieldName || this.state.titleOilField,
                            titleOpUnit: element.uopName || this.state.titleOpUnit,
                            listOilfieldCache: element.oilFields || this.state.listOilfieldCache,
                            listWellCache: element.wells || this.state.listWellCache,
                            currentLevelTree: TypeTreeWellObj.FILES,
                            loaded: true,
                            error: null
                        })
                        break
                    case TypeTreeWellObj.FILE:
                        if (this.showRevisions) {
                            providerImport.getByUrl(result.revisions).then((revisions: any) => {
                                this.setState({
                                    searchTxt: '',
                                    list: revisions.sort(SortCompareFileType),
                                    listCache: revisions.sort(SortCompareFileType),
                                    listRevisionsCache: revisions.sort(SortCompareFileType),
                                    titleFile: titleTree,
                                    currentLevelTree: TypeTreeWellObj.REVISIONS,
                                    loaded: true,
                                    error: null
                                })
                            })
                            break
                        } else {
                            this.setState({
                                loaded: true,
                                error: null,
                                showOptionsImport: true,
                                enable: true,
                                currentLevelTree: TypeTreeWellObj.CARD_OPTIONS
                            })
                            this.valid = true
                            this.wellFile = result
                            
                            if(this.wellFile?.file_type !== SEEDS_DRILLING_FILE_TYPE) {
                                this.props.setEnable(true)
                            }

                            break
                        }

                    case TypeTreeWellObj.REVISION:
                        this.setState({
                            loaded: true,
                            error: null,
                            showOptionsImport: true,
                            enable: true,
                            currentLevelTree: TypeTreeWellObj.CARD_OPTIONS
                        })
                        this.valid = true
                        this.wellFile = result
                        this.props.setEnable(true)
                        break
                    default:
                        break
                }
            })
            .catch(error => {
                console.error(error)
                this.setState({ error: error, loaded: true })
            })
    }

    selectItemList = (element: any, index: number) => {
        this.setState({ showMsg: '', selectedName: element?.name })
        switch (this.state.currentLevelTree) {
            case TypeTreeWellObj.OP_UNITS:
                this.setState({
                    searchTxt: '',
                    showSearchResults: false,
                    list: element.oilfields.sort(SortCompareName),
                    listCache: element.oilfields.sort(SortCompareName),
                    listOilfieldCache: element.oilfields.sort(SortCompareName),
                    titleOpUnit: element.name,
                    currentLevelTree: TypeTreeWellObj.OIL_FIELDS
                })
                break
            case TypeTreeWellObj.OIL_FIELDS:
                this.setState({
                    searchTxt: '',
                    showSearchResults: false,
                    list: element.wells.sort(SortCompareName),
                    listCache: element.wells.sort(SortCompareName),
                    listWellCache: element.wells.sort(SortCompareName),
                    titleOilField: element.name,
                    currentLevelTree: TypeTreeWellObj.WELLS
                })
                this.oilField = element
                break
            case TypeTreeWellObj.WELLS:
                this.getByUrl(element.url, TypeTreeWellObj.WELLS, TypeTreeWellObj.FILES, element.name, element, index)
                break
            case TypeTreeWellObj.FILES:
                this.setState({
                    showSearchResults: false
                })

                if (this.isAttachment) {
                    const idRev = ImportUtil.getFileIdRevision(element.url)
                    this.setState({
                        file: {
                            fileId: idRev.fileId,
                            fileRevision: idRev.fileRevision,
                            wellName: this.state.titleWell,
                            name: element.name
                        }
                    })
                    this.props.setEnable(true)
                } else {
                    this.getByUrl(element.url, TypeTreeWellObj.FILE, '', element.name, element, index)
                }
                break
            case TypeTreeWellObj.REVISIONS:
                this.setState({ selectedFile: { name: element.created_at, url: element.url } })
                this.getByUrl(element.url, TypeTreeWellObj.REVISION, '', element.created_at, element, index)
                break
            default:
                break
        }
    }

    onChangeSearch = (event: React.BaseSyntheticEvent): void => {
        const value = event.target.value
        this.clearBackToOpUnit(value)

        const wells = this.searchWellsByName(this.state.listOpUnitsCache, value)
        if (wells && value) {
            this.setState({
                list: wells,
                showTitle: false,
                currentLevelTree: TypeTreeWellObj.WELLS,
                showSearchResults: true,
                showOptionsImport: false
            })
        }

        if (!value || value === '') {
            this.onClickInitTree()
        }
    }

    searchWellsByName(uopList: Array<any>, wellName: string): Array<object> | null {
        if (!wellName) return null
        const wellFoundArray = ImportUtil.searchWellsByName(uopList, wellName)
        if (wellFoundArray) {
            return wellFoundArray
        } else {
            return null
        }
    }

    clearBackToOpUnit(searchTxt): void {
        this.setState({
            showTitle: true,
            currentLevelTree: TypeTreeWellObj.OP_UNITS,
            list: this.state.listOpUnitsCache,
            titleOpUnit: '',
            titleOilField: '',
            titleWell: '',
            titleFile: '',
            searchTxt: searchTxt
        })
    }

    onClickInitTree(): void {
        this.setState({
            showTitle: true,
            titleOpUnit: '',
            titleOilField: '',
            titleWell: '',
            showSearchResults: false,
            titleFile: '',
            list: this.state.listOpUnitsCache,
            listCache: this.state.listOpUnitsCache,
            currentLevelTree: TypeTreeWellObj.OP_UNITS,
            error: null,
            searchTxt: ''
        })
    }

    onKeyDownSearch = (e: any): void => {
        // enter
        if (e.keyCode == 13) {
            if (!this.state.showOptionsImport && this.state.list && this.state.list[0]) {
                this.selectItemList(this.state.list[0])
            } else if (!this.state.showOptionsImport && this.state.listWebConfig && this.state.listWebConfig[0]) {
                this.selectWebConfig(this.state.listWebConfig[0])
            } else if (this.state.showOptionsImport) {
                this.onSelectWellCard({
                    description: true,
                    location: true,
                    sections: true,
                    geopressures: true,
                    trajectory: true,
                    temperatures: true
                })
            }
        }
    }

    backTree = (levelTree: string): void => {
        switch (levelTree || this.state.currentLevelTree) {
            case TypeTreeWellObj.OP_UNITS:
                this.setState({
                    searchTxt: '',
                    list: this.state.listOpUnitsCache,
                    listCache: this.state.listOpUnitsCache,
                    currentLevelTree: TypeTreeWellObj.OP_UNITS,
                    titleOpUnit: '',
                    titleOilField: '',
                    titleWell: '',
                    titleFile: '',
                    error: null
                })
                break
            case TypeTreeWellObj.OIL_FIELDS:
                this.setState({
                    searchTxt: '',
                    list: this.state.listOilfieldCache,
                    listCache: this.state.listOilfieldCache,
                    currentLevelTree: TypeTreeWellObj.OIL_FIELDS,
                    titleOilField: '',
                    titleWell: '',
                    titleFile: ''
                })
                break
            case TypeTreeWellObj.WELLS:
                this.setState({
                    searchTxt: '',
                    list: this.state.listWellCache,
                    listCache: this.state.listWellCache,
                    currentLevelTree: TypeTreeWellObj.WELLS,
                    titleWell: '',
                    titleFile: ''
                })
                break
            case TypeTreeWellObj.FILES:
                this.setState({
                    list: this.state.listFileCache,
                    listCache: this.state.listFileCache,
                    currentLevelTree: TypeTreeWellObj.FILES,
                    titleFile: ''
                })
                break
            case TypeTreeWellObj.FILE:
                this.setState({
                    list: this.state.listRevisionsCache,
                    listCache: this.state.listRevisionsCache,
                    currentLevelTree: TypeTreeWellObj.REVISION
                })
                break
            default:
                break
        }
    }

    selectWebConfig = (webConfig: webConfig): void => {
        providerImport.setRequestOptions(webConfig)
        this.setState({ showOptionsImport: false, showTitle: true, currentLevelTree: TypeTreeWellObj.OP_UNITS })
        if (this.isAttachment && !webConfig.enableCsb) {
            this.defineWebConfigError()
            return
        }
        this.getTree()
    }

    defineWebConfigError() {
        this.setState({ error: { msg: i18n('This instance is not enabled to import files') } })
    }

    onSelectWellCard = (wellCard: WellCard): void => {
        this.wellCard = wellCard
        if (_.isEmpty(wellCard)) {
            this.valid = false
            this.setState({ enable: false })
        } else {
            this.valid = true
            this.setState({ enable: true })
        }
    }

    onSubmit = (): void => {
        if (!this.valid) return
        this.valid = true
        if (this.wellFile?.file_type == SEEDS_DRILLING_FILE_TYPE && this.state.timestamp) {
            const wellFileImport = {sections:{sections: parseSeedsDataToLiveData(this.wellFile, this.state.timestamp)}}
            const converted = ConversionUtil.convertCompletionAbandonment(
                this.wellFile?.revision?.content?.input,
                this.props.checkedItens,
                wellFileImport
                // this.phaseOptions
            )
            this.props.onSelectFile(converted)
        } else if (this.props.checks && this.wellFile?.revision?.content?.input) {
            if (
                this.props.checkedItens &&
                Object.keys(this.props.checkedItens).every(prop => !this.props.checkedItens[prop])
            ) {
                globalNotification.error(i18n('Select at least one option'))

                return
            }
            if (this.wellFile.revision.content.input?.abandonment?.anm_model) {
                this.wellFile.revision.content.input.abandonment.anm_model =
                    AnmModel[this.wellFile.revision.content.input.abandonment.anm_model]
            }
            this.wellCard = this.props.checkedItens
            const wellFileImport: WellFileImport = ConversionUtil.convertWell(
                this.wellFile,
                this.oilField,
                this.wellCard,
                this.props.typeAsset,
                this.state.phaseOptions
            )
            const converted = ConversionUtil.convertCompletionAbandonment(
                this.wellFile?.revision?.content?.input,
                this.props.checkedItens,
                wellFileImport
                // this.phaseOptions
            )
            this.props.onSelectFile(converted)
        } else {
            const wellFileImport: WellFileImport = ConversionUtil.convertWell(
                this.wellFile,
                this.oilField,
                this.wellCard,
                this.props.typeAsset,
                this.state.phaseOptions
            )
            this.props.onSelectFile(wellFileImport)
        }
    }

    back = (): void => {
        const { error } = this.state
        if (error) this.backTree(TypeTreeWellObj.OP_UNITS)
        else this.backTree(TypeTreeWellObj.WELLS)
    }

    getAttachment = (fileId: string, fileRevision: string): void => {
        this.props.setEnable(false)
        this.setState({ loaded: false })
        providerImport
            .getAttachment(fileId, fileRevision)
            .then((attachment: Object) => {
                this.setState({
                    loaded: true,
                    error: null
                })
                this.valid = true
                if (attachment?.message) {
                    this.handleError(attachment)

                    return
                }
                this.setState({ loaded: true })
                this.props.onSelectFile({ svg: attachment.response, file: this.state.file })
            })
            .catch(this.handleError)
    }

    handlePhaseOptions = options => {
        this.setState({ phaseOptions: options })
    }

    handleChangeTimestamp = timestamp => {
        this.setState({ timestamp })
    }

    render() {
        const { error, currentLevelTree, loaded, showOptionsImport } = this.state

        return (
            <Content>
                <div>
                    {!error && !showOptionsImport && currentLevelTree != TypeTreeWellObj.WEB_CONFIG && (
                        <ContainerInput>
                            <i className="fas fa-search" style={{ background: loaded ? 'white' : '#eeeeee' }} />
                            <input
                                className="searchTxt"
                                type="text"
                                disabled={!loaded}
                                style={{
                                    background: loaded ? 'white' : '#eeeeee',
                                    cursor: loaded ? 'default' : 'not-allowed',
                                    'box-shadow': 'none'
                                }}
                                placeholder={i18n('SearchWell')}
                                value={this.state.searchTxt}
                                onChange={this.onChangeSearch}
                                ref={input => input && input.focus()}
                            />
                            {this.state.searchTxt && loaded && (
                                <i
                                    className="fas fa-times"
                                    onClick={() => {
                                        if (this.state.searchTxt) {
                                            this.onClickInitTree()
                                        }
                                    }}
                                    style={{ background: loaded ? 'white' : '#eeeeee' }}
                                />
                            )}
                        </ContainerInput>
                    )}{' '}
                    {!this.state.error && currentLevelTree != TypeTreeWellObj.WEB_CONFIG && (
                        <ContainerSubtitle>
                            {showOptionsImport && (
                                <ContainerBack
                                    onClick={() => {
                                        this.setState({
                                            showTitle: true,
                                            currentLevelTree: TypeTreeWellObj.FILES,
                                            showOptionsImport: false,
                                            list: this.state.list.sort(SortCompareName),
                                            listCache: this.state.listCache.sort(SortCompareName),
                                            listWellCache: this.state.listWellCache.sort(SortCompareName),
                                            listOpUnitsCache: this.state.listOpUnitsCache.sort(SortCompareName),
                                            loaded: true,
                                            error: null,
                                            searchTxt: ''
                                        })
                                    }}
                                >
                                    <i className="fas fa-arrow-left" />
                                    <span>
                                        {i18n('Back to well')} {this.state.assetName}
                                    </span>
                                </ContainerBack>
                            )}
                            {this.state.showSearchResults && <div>{i18n('Search results')}</div>}
                            {!showOptionsImport && this.state.showTitle && (
                                <Subtitle>
                                    <ContentActive
                                        active={!this.state.titleOpUnit ? 'active' : ''}
                                        onClick={() => {
                                            loaded && this.state.titleOpUnit && this.backTree(TypeTreeWellObj.OP_UNITS)
                                        }}
                                    >
                                        {i18n('uop')}
                                    </ContentActive>
                                    {this.state.titleOpUnit && (
                                        <ContentActive
                                            active={!this.state.titleOilField ? 'active' : ''}
                                            onClick={() => {
                                                loaded &&
                                                    this.state.titleOilField &&
                                                    this.backTree(TypeTreeWellObj.OIL_FIELDS)
                                            }}
                                        >
                                            <i>/</i>
                                            {this.state.titleOpUnit}
                                        </ContentActive>
                                    )}
                                    {!error && this.state.titleOilField && (
                                        <ContentActive
                                            active={!this.state.titleWell ? 'active' : ''}
                                            onClick={() => {
                                                loaded &&
                                                    this.state.titleOilField &&
                                                    this.backTree(TypeTreeWellObj.WELLS)
                                            }}
                                        >
                                            <i>/</i>
                                            {this.state.titleOilField}
                                        </ContentActive>
                                    )}
                                    {!error && this.state.titleWell && (
                                        <ContentActive
                                            active={!this.state.titleFile ? 'active' : ''}
                                            onClick={() => {
                                                loaded && this.state.titleWell && this.backTree(TypeTreeWellObj.FILES)
                                            }}
                                        >
                                            <i>/</i>
                                            {this.state.titleWell}
                                        </ContentActive>
                                    )}
                                    {!error && this.state.titleFile && (
                                        <ContentActive
                                            active={this.state.titleFile ? 'active' : ''}
                                            onClick={() => {
                                                loaded && this.state.titleFile && this.backTree(TypeTreeWellObj.FILE)
                                            }}
                                        >
                                            <i>/</i>
                                            {this.state.titleFile}
                                        </ContentActive>
                                    )}
                                </Subtitle>
                            )}
                        </ContainerSubtitle>
                    )}
                </div>
                <BodyContent>
                    {!error &&
                        this.state.listWebConfig &&
                        this.state.showWebConfig &&
                        !showOptionsImport &&
                        this.state.listWebConfig?.map((webConfig: webConfig, key) => (
                            <ListItemContainer
                                key={key}
                                className="listItem borderItem"
                                onClick={() => this.selectWebConfig(webConfig)}
                            >
                                <i className="fal fa-sitemap" style={{ marginRight: '10px' }}></i>
                                <span>{webConfig.qualifier || webConfig.uri || 'liverig-pocoweb-wellimport'} </span>
                            </ListItemContainer>
                        ))}
                    {!loaded && <Loading className="loading" />}
                    {loaded &&
                        this.state.list &&
                        !error &&
                        !showOptionsImport &&
                        this.state.list?.map((element: any, index: number) => {
                            return (
                                <ListItemContainer
                                    key={index}
                                    elementName={element.uopName && element.oilFieldName}
                                    onClick={() => this.selectItemList(element, index)}
                                    for={index}
                                >
                                    <div>
                                        {!element.created_at && (
                                            <ListItem>
                                                <div>
                                                    {element.file_type ? (
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            {this.isAttachment && (
                                                                <input
                                                                    style={{ marginRight: '11px' }}
                                                                    type="radio"
                                                                    id={index}
                                                                />
                                                            )}
                                                            <FileIcon
                                                                name={ReplaceFileTypeUtil(element.file_type)}
                                                                fileType={element.file_type.replace('.', '')}
                                                            />
                                                        </div>
                                                    ) : (
                                                        <i className="fas fa-folder" />
                                                    )}
                                                </div>
                                                <div>
                                                    <TitleName>{element.name}</TitleName>
                                                    <TreeElement>
                                                        {element.uopName && <span> / {element.uopName}</span>}
                                                        {element.oilFieldName && <span> / {element.oilFieldName}</span>}
                                                    </TreeElement>
                                                </div>
                                            </ListItem>
                                        )}
                                        {element.created_at && (
                                            <span className="createdAt">
                                                {ImportUtil.getDate(element.created_at)}
                                                {element.description && <span> ({element.description}) </span>}
                                            </span>
                                        )}
                                    </div>
                                </ListItemContainer>
                            )
                        })}
                    {!error && showOptionsImport && !this.props.checks && (
                        <WellImportOption
                            geoTable={this.state.geoTable}
                            onSelectWellCard={this.onSelectWellCard}
                            typeAsset={this.props.typeAsset}
                            selectedName={this.state.selectedName}
                        />
                    )}
                    {!error && showOptionsImport && this.props.checks && (
                        <React.Fragment>
                            {this.state.selectedName && (
                                <StyledDiv>{`${i18n('seeds-import-data-message')}`}</StyledDiv>
                            )}
                            {this.wellFile?.file_type == SEEDS_DRILLING_FILE_TYPE ? (
                                <ImportSeedsDataByDate
                                    wellFile={this.wellFile}
                                    onChangeTimestamp={this.handleChangeTimestamp}
                                    startTimestamp={this.props.startTimestamp}
                                    setEnable={this.props.setEnable}
                                    submited={this.submited}
                                />
                            ) : (
                                this.props.checks?.map((element, key) => (
                                    <OptionContent key={key} isSelectAll={!key}>
                                        <ContainerCheckBox>
                                            <Checkbox
                                                type="checkbox"
                                                name="description"
                                                checked={this.props.checkedItens[element.key]}
                                                onChange={event => this.props.onCheck(event, element)}
                                                key={key}
                                            >
                                                {i18n(element.description)}
                                            </Checkbox>
                                            {element.key === 'sections' && this.props.checkedItens[element.key] && (
                                                <PhasesOptions
                                                    phases={this.wellFile?.revision?.content?.input?.phases}
                                                    drillingSections={this.props.drillingSections}
                                                    handlePhaseOptions={this.handlePhaseOptions}
                                                />
                                            )}
                                        </ContainerCheckBox>
                                    </OptionContent>
                                ))
                            )}
                        </React.Fragment>
                    )}
                    {error && (
                        <ErrorStyled>{i18n(error.msg || (loaded && ConstantsImport.msg.genericError))}</ErrorStyled>
                    )}

                    {((!error && this.state.list?.length === 0 && this.state.webConfig?.length === 0) ||
                        !this.state.list) && (
                        <NoResults
                            onClearResults={() =>
                                this.setState({
                                    showTitle: true,
                                    titleOpUnit: '',
                                    titleOilField: '',
                                    showSearchResults: false,
                                    titleWell: '',
                                    titleFile: '',
                                    list: this.state.listOpUnitsCache,
                                    listCache: this.state.listOpUnitsCache,
                                    currentLevelTree: TypeTreeWellObj.OP_UNITS,
                                    error: null,
                                    searchTxt: ''
                                })
                            }
                        />
                    )}
                </BodyContent>
            </Content>
        )
    }
}

export default WellImportData
